import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {Container, Grid, GridColumn} from "semantic-ui-react";

class ApplySuccess extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    hexColorCodeC: PropTypes.string.isRequired,
  };

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <Container id="mainContent" className="ui">
          <Grid className="ui">
            <GridColumn className="pageShowTitle">
              <h3
                className="ui dividing header"
                style={{ color: `#${this.props.hexColorCodeC}` }}
              >
                {this.props.show.name} Casting
              </h3>
            </GridColumn>
          </Grid>

          <Grid className="ui stackable">
            <div className="ui sixteen wide mobile eight wide computer column">
              <h1>Thank you for applying!</h1>
              <div className="ui grid">
                <div className="eight wide mobile eight wide tablet eight wide computer column">
                  <Link to="/home">
                    <div className="ui fluid huge primary right labeled icon button"
                         style={{ backgroundColor: `#${this.props.hexColorCodeC}` }}>
                      <i className="right chevron icon" />
                      Back to Home
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </Grid>
        </Container>
      </div>
    );
  }
}

// const mapDispatchToProps = dispatch => ({
//   navigateTo: location => {
//     dispatch(push(location));
//   },
// });

export default ApplySuccess;



// WEBPACK FOOTER //
// ./src/components/ApplySuccess.js